import React from "react";
import OfferCard from "./OfferCard";
import topBackground from "../../../../Assets/Images/topbgImg.svg";
import storeDefault from "../../../../Assets/Icons/storeDefault.svg";
import { ReactComponent as TopNav } from "../../../../Assets/Images/topNav.svg";
import { ReactComponent as BackWhiteIcon } from "../../../../Assets/Icons/backWhiteIcon.svg";
import StarRatings from "react-star-ratings";

const MerchantDetails = ({ merchantData, offerData, selectedMerchant }) => {
  return (
    <div className="h-[500px] sm:w-[320px] lg:w-[320px] 2xl:w-[320px] bg-white drop-shadow-[0_4px_4px_rgba(0,0,0,0.15)] relative overflow-y-scroll" style={{scrollbarWidth: 'none'}}>
      <img src={topBackground} className="w-full" alt="top background" />
      <BackWhiteIcon className="absolute top-[22px] left-[8px]" />
      <TopNav
        className="absolute"
        style={{
          top: '55px',
          left: '-6px',
          width: '100%',
          height: '30px',
          transform: 'translateX(-2px) scale(0.94)',
          transformOrigin: 'left top',
          pointerEvents: 'none'
        }}
      />
      <div className="p-4" style={{ paddingTop: '14px' }}>
        <div className="flex justify-start items-center gap-3">
          <img
            src={(function(){
              // Only show store/location logo; otherwise show default store icon
              const locLogo = offerData?.tempLocations?.[0]?.logo || merchantData?.location?.logo;
              if (!locLogo || (typeof locLogo === 'string' && locLogo.trim() === '')) return storeDefault;
              const isAbs = typeof locLogo === 'string' && /^(https?:)?\/\//i.test(locLogo);
              return isAbs ? locLogo : `${process.env.REACT_APP_S3_URL || ''}${locLogo}`;
            })()}
            alt="merchant logo"
            className="w-[18px] h-[18px] object-contain"
          />
          <p className="text-[#303030] font-poppins font-[500] text-[14px] whitespace-nowrap">
            {(function(){
              // Show store name (franchise/location name) if available; otherwise merchant business name
              const storeName = offerData?.tempLocations?.[0]?.name || merchantData?.location?.merchant?.businessName || merchantData?.location?.name;
              const merchantNameFallback = offerData?.merchant?.businessName || offerData?.merchant?.user?.name || merchantData?.location?.merchant?.user?.name;
              return storeName || merchantNameFallback || '';
            })()}
          </p>
        </div>
        <div className="flex justify-start items-center gap-2 mt-2">
          <div>
            <StarRatings
              rating={merchantData?.location?.googlePlaceId?.rating !== undefined
                ? merchantData?.location?.googlePlaceId?.rating
                : 3.0}
              starRatedColor="#FDD77D"
              starDimension="14px"
              starSpacing="0.3px"
              numberOfStars={5}
              name="rating"
            />
          </div>
          <p className="text-[#303030] font-poppins font-[500] text-[10px] mt-[1.5px]">
            {merchantData?.location?.googlePlaceId?.rating
              ? merchantData?.location?.googlePlaceId?.rating
              : "3.0"}{" "}
            (1)
          </p>
          <div className="flex justify-center items-center gap-1">
            <p className="text-[#303030] font-poppins font-[700] text-[11px] mb-1">
              .
            </p>
            <p className="text-[#303030] font-poppins font-[500] text-[10px] mt-[1.5px]">
              {merchantData?.location?.formattedDistance}
            </p>
          </div>
        </div>
        <p className="mt-3 text-[#303030] font-poppins font-[500] text-[12px] whitespace-nowrap">
          All Offers
        </p>
        <div className="flex flex-col mt-2 w-full gap-3">
          <OfferCard
            img={(function(){
              const url = offerData?.thumbnailImage;
              const isAbsolute = typeof url === 'string' && /^(https?:)?\/\//i.test(url);
              return isAbsolute ? url : `${process.env.REACT_APP_S3_URL || ''}${url || ''}`;
            })()}
            title={offerData?.title}
            description={offerData?.description}
            discount={
              offerData?.discountTitle ||
              (offerData?.discountRange !== undefined && offerData?.discountRange !== null
                ? `Discounted Offer ${offerData?.discountRange}%`
                : "")
            }
            location={(function(){
              // Prefer the first selected location on the offer, then merchantData fallback
              const fromOffer = offerData?.tempLocations?.[0]?.googlePlaceId?.address
                || offerData?.tempLocations?.[0]?.address
                || offerData?.location?.formattedAddress;
              const fromMerchant = merchantData?.location?.formattedAddress || merchantData?.location?.address;
              return fromOffer || fromMerchant || "";
            })()}
            distance={merchantData?.location?.formattedDistance}
          />
          {merchantData?.offers?.map(
            (offer, index) =>
              index > 0 &&
              index <= 3 && (
                <OfferCard
                  img={(function(){
                    const url = offer?.thumbnailImage;
                    const isAbsolute = typeof url === 'string' && /^(https?:)?\/\//i.test(url);
                    return isAbsolute ? url : `${process.env.REACT_APP_S3_URL || ''}${url || ''}`;
                  })()}
                  title={offer?.title}
                  description={offer?.discountTitle}
                  discount={
                    offer?.discountTitle ||
                    (offer?.discountRange !== undefined && offer?.discountRange !== null
                      ? `Discounted Offer ${offer?.discountRange}%`
                      : "")
                  }
                  location={offer?.location?.formattedAddress}
                  distance={offer?.location?.formattedDistance}
                />
              )
          )}
        </div>
      </div>
    </div>
  );
};

export default MerchantDetails;
